export default "__VITE_ASSET__TbqzH9GD__"